// extracted by mini-css-extract-plugin
export default {"error_page_container":"error-page_error_page_container__mQjUt","spacer":"error-page_spacer__uYwqC"};